module.exports = __webpack_public_path__ + "static/media/duplicate.2c3af933.svg";